<template>
	<span v-if="visible">{{ listItemName }}</span>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {injectFindList} from "../PartInjectKeys";
import {computed, ref} from "vue";
import type {Text} from "@t/fd/fixed/Text";
import {injectEnv} from "../Environment";
import type {PanelDescriptor} from "../Types";
import type {UserGroup} from "@t/fd/editor/UserGroup";

const uprops = defineProps({
	...editorProps
});
const props = uprops as EditorProps;
const {visible, value} = useEditor(props);

const ug = computed<UserGroup>(() => props.part as UserGroup);

const env = injectEnv();
const findList = injectFindList();
const ugList = ref(buildUserGroupList());
const listItemName = computed(() => {
	let varr = value.value;
	if (varr === null || typeof varr === "undefined") return "";
	if (!Array.isArray(varr)) varr = [varr];
	const names = [];
	for (let v of varr) {
		let found = false;
		for (let li of ugList.value) {
			if (li.value === v) {
				names.push(li.name);
				found = true;
				break;
			}
		}
		if (!found) names.push("(" + v + ")");
	}
	return names.join(", ");
});

function buildUserGroupList() {
	const b = [];
	for (let li of findList("ALL_USERS").value) {
		b.push(li);
	}
	for (let li of findList("ALL_GROUPS").value) {
		b.push(li);
	}
	return b;
}

function invokePicker(labelPart: Text) {
	let valArray = value.value;
	if (!Array.isArray(valArray)) valArray = [valArray];
	const pg: PanelDescriptor = {
		component: "user-group-page",
		bind: {
			users: findList("USERS", ...valArray),
			groups: findList("GROUPS", ...valArray),
			selected: value.value,
			multi: !!ug.value.multi,
			required: ug.value.required,
			pageTitle: labelPart.value,
		}
	};
	env.showPanel(pg)
		.then((result: any) => {
			value.value = result;
		});
}


defineExpose({
	invokePicker
});
</script>

<style></style>
